// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_2ozx0","background":"_1pL71","icon":"i5koQ","maintenanceIcon":"_34VG7","message":"_35AuI","backCta":"_1XT4_"};